import React from "react";
import { Reveal } from "../shared/Reveal";

export default function StopWasteBanner() {
  return (
    <section className="stopwaste" data-testid="stop-waste-banner">
      <div className="wrap">
        <Reveal className="stopwaste-card" tag="div">
          <img
            src="/brand/mk_stop_wasting_energy.jpg"
            alt="Stop Wasting Energy, Start Protecting Profits — Energy Vault Group"
            loading="lazy"
          />
        </Reveal>
        <Reveal className="stopwaste-cta" tag="div">
          <a href="/gap-analysis" className="btn" data-testid="stop-waste-cta">Book Your Free Gap Analysis</a>
        </Reveal>
      </div>
    </section>
  );
}
